import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FilesUpload,
  title: 'Files Upload',
  category: ComponentCategory.General,
};
